




























import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "GroupHeader",
  props: {
    type: { type: String, required: true }
  }
});
